import { CommonData } from '../common_schema'

export const schedulerData: CommonData[] = [
  {
    name: 'prewrite_Scheduler latch wait duration(p99)',
    mean: 'Latch_wait_duration_prewrite:total.values.mean',
    std: 'Latch_wait_duration_prewrite:total.values.std',
    location:
      'TiKV-Details --> Scheduler - prewrite --> Scheduler latch wait duration'
  },
  {
    name: 'prewrite_Scheduler command duration(p99)',
    mean: 'Latch_command_duration_prewrite:total.values.mean',
    std: 'Latch_command_duration_prewrite:total.values.std',
    location:
      'TiKV-Details --> Scheduler - prewrite --> Scheduler command duration'
  },
  {
    name: 'commit_Scheduler latch wait duration(p99)',
    mean: 'Latch_wait_duration_commit:total.values.mean',
    std: 'Latch_wait_duration_commit:total.values.std',
    location:
      'TiKV-Details --> Scheduler - commit --> Scheduler latch wait duration'
  },
  {
    name: 'commit_Scheduler command duration(p99)',
    mean: 'Latch_command_duration_commit:total.values.mean',
    std: 'Latch_command_duration_commit:total.values.std',
    location:
      'TiKV-Details --> Scheduler - commit --> Scheduler command duration'
  },
  {
    name: 'Scheduler pending commands(max between all TiKVs)',
    mean: 'scheduler_pending_command_max:total.values.mean',
    std: 'scheduler_pending_command_max:total.values.std',
    location: 'TiKV-Details --> Scheduler --> Scheduler pending commands'
  },
  {
    name: 'Scheduler write bytes(max between all TiKVs)',
    mean: 'scheduler_writing_bytes_max:total.values.mean',
    std: 'scheduler_writing_bytes_max:total.values.std',
    location: 'TiKV-Details --> Scheduler --> Scheduler writing bytes'
  }
]
